import React from "react";
import {
  //   FaLinkedinIn,
  //   FaTwitter,
  //   FaInstagram,
  //   FaYoutube,
  FaChevronRight,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
} from "react-icons/fa";
import { NavLink } from "react-router-dom";

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          <div className="footer-about">
            <a href="#home" className="footer-logo">
              <div className="footer-logo-icon">AM</div>
              <div className="footer-logo-text">AL Mawarid</div>
            </a>
            <p>
              Providing reliable and quality-driven MEP and ELV solutions in
              Oman since 2018. We combine technical expertise with innovative
              solutions to deliver exceptional value.
            </p>

            {/* <div className="social-links">
              <a href="#">
                <FaLinkedinIn />
              </a>
              <a href="#">
                <FaTwitter />
              </a>
              <a href="#">
                <FaInstagram />
              </a>
              <a href="#">
                <FaYoutube />
              </a>
            </div> */}
          </div>

          <div className="footer-links">
            <h3 className="footer-heading">Quick Links</h3>
            <ul>
              <li>
                <NavLink to="/" end>
                  <FaChevronRight /> Home
                </NavLink>
              </li>

              <li>
                <NavLink to="/about">
                  <FaChevronRight /> About Us
                </NavLink>
              </li>

              <li>
                <NavLink to="/services">
                  <FaChevronRight /> Services
                </NavLink>
              </li>

              <li>
                <NavLink to="/projects">
                  <FaChevronRight /> Projects
                </NavLink>
              </li>
              <li>
                <NavLink to="/partners">
                  <FaChevronRight /> Partners
                </NavLink>
              </li>
              <li>
                <NavLink to="/contact">
                  <FaChevronRight /> Contact
                </NavLink>
              </li>
            </ul>
          </div>

          <div className="footer-contact">
            <h3 className="footer-heading">Contact Information</h3>
            <div className="contact-info">
              <div className="contact-item">
                <FaMapMarkerAlt className="contact-icon" />
                <div>
                  <strong>Location</strong>
                  <p>
                    Building 1354, PO Box 134
                    <br />
                    Al Qurum, Muscat, Oman
                  </p>
                </div>
              </div>

              <div className="contact-item">
                <FaPhoneAlt className="contact-icon" />
                <div>
                  <strong>Phone Numbers</strong>
                  <p>
                    +968 99022277
                    <br />
                    +968 91462084
                  </p>
                </div>
              </div>

              <div className="contact-item">
                <FaEnvelope className="contact-icon" />
                <div>
                  <strong>Email Addresses</strong>
                  <p>
                    alyaqdhan@almawaridoman.com
                    <br />
                    vignesh.potti@almawaridoman.com
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="copyright">
          <p>
            &copy; 2025 AL Mawarid Services & Maintenance SPC. All rights
            reserved. | Sea Sense
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
